import { type Config, Envs } from '../interfaces';

export const LOCAL_CONFIG_PART: Partial<Config> = {
  apiUrl: 'http://localhost:3000',
  environment: Envs.local,
  proxyEnabled: true,
  gtmContainerId: 'GTM-MLMGX9C',
  auth: {
    oktaTokenUrl: '/okta/oauth2/aus2pnx40clt6Yygg1d7/v1/token',
    oktaIntrospectUrl: '/okta/oauth2/aus2pnx40clt6Yygg1d7/v1/introspect',
    oktaClientId: '0oawmgleirAKvaJkf1d7',
    redirectUri: 'http://localhost:4200',
    oktaRedirectUri: 'https://marketplace-qa.icweb-test.alpaque.net/login/callback',
    webAuthSignInUrl: 'https://okta-auth-cloudfront-qa.webo-test.alpaque.net/en?appId=bltce92f3cd1ce7591d',
  },
  rewardsContent: {
    baseUrl: '', // local: relative /csconfig/* so the dev-server proxy (proxy.conf.js) handles CORS
  },
  loyaltyApiUrl: '/loyalty',
  monthlyStatementContent: { baseUrl: '' },
};
